/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Check } from '@saleshandy/icons';
import { useHistory } from 'react-router-dom';
import Modal from '../../../../shared/design-system/components/atoms/modal';
import Button from '../../../../shared/design-system/components/atoms/button';
import { Images } from '../../../../shared/app-constants';
import hasPermission from '../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../shared/utils/access-control/enums/permissions';
import { Routes } from '../../../../shared/routes';
import { contactAdmin } from '../../../../shared/utils/contact-admin';

interface Props {
  show: boolean;
  onClose: () => void;
}

export default function UpgradeFilterModal({ show, onClose }: Props) {
  const history = useHistory();

  return (
    <Modal
      show={show}
      className="upgrade-pro-modal"
      hideHeader
      showCloseIcon
      hideFooter
      onClose={onClose}
      backdrop="static"
    >
      <div className="upgrade-modal-content d-flex flex-column gap-24 justify-content-center align-items-center">
        <div className="upgrade-modal-header">
          <div className="d-flex align-items-center justify-content-center">
            <img src={Images.ApplySearch} alt="Unlock" />
          </div>
          <span className="d-flex justify-content-center title">
            Upgrade to Pro Plan for Advanced Filters
          </span>
        </div>
        <div className="upgrade-features-list d-flex flex-column gap-12">
          <div className="d-flex gap-12 align-items-center">
            <Check width={16} height={16} color="#047857" />
            <span className="category-list">
              Advanced people filters: job changes, tenure, seniority &
              department breakdowns
            </span>
          </div>
          <div className="d-flex gap-12 align-items-center">
            <Check width={16} height={16} color="#047857" />
            <span className="category-list">
              Company intelligence: funding, revenue, employee count & B2B
              identification
            </span>
          </div>
          <div className="d-flex gap-12 align-items-center">
            <Check width={16} height={16} color="#047857" />
            <span className="category-list">
              Real-time signals: executive hires, scaling teams, fresh funding &
              hiring trends
            </span>
          </div>
          <div className="d-flex gap-12 align-items-center">
            <Check width={16} height={16} color="#047857" />
            <span className="category-list">
              Market insights: salary data, employee reviews, company news &
              expansion alerts
            </span>
          </div>
        </div>
        <div className="d-flex flex-column gap-12">
          <Button
            variant={'primary' as any}
            className="upgrade-pro-btn"
            onClick={() => {
              onClose();
              if (hasPermission(Permissions.ACCOUNT_SUBSCRIPTION_READ)) {
                history.push(Routes.Setting_Billing_Upgrade_Lead_Finder_Plan);
              } else {
                contactAdmin(
                  'Upgrade request',
                  'Please upgrade my account to Pro to unlock premium filters.',
                );
              }
            }}
          >
            Upgrade to Pro
          </Button>
          <Button
            variant={'link' as any}
            className="maybe-later-btn"
            onClick={onClose}
          >
            Maybe Later
          </Button>
        </div>
      </div>
    </Modal>
  );
}
